import axios from "axios";
import Utils from "../utils/utils";
import AppLib from "./AppLib";

const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
let token = Utils.getToken();

const Projects = {
  SUBJECT: {
    1: "Data Analytics with Python",
    2: "SQL",
    3: "Power BI",
  },
  LEVEL: {
    1: { name: "Begineer", text: "text-green-700", bg: "bg-green-100" },
    2: { name: "Intermediate", text: "text-amber-700", bg: "bg-amber-100" },
    3: { name: "Advance", text: "text-red-700", bg: "bg-red-100" },
  },
  createProject: async function (formData) {
    try {
      const response = await axios.post(`${SERVER_URL}/projects`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.project,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  updateDocuments: async function (id, formData) {
    try {
      const response = await axios.put(
        `${SERVER_URL}/projects/docs/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  publishProject: async function (id, formData) {
    try {
      const response = await axios.put(
        `${SERVER_URL}/projects/publish/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  updateProject: async function (id, formData) {
    try {
      const response = await axios.put(
        `${SERVER_URL}/projects/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  getProjects: async function () {
    if (!token) token = AppLib.token; // Get t
    try {
      const response = await axios.get(`${SERVER_URL}/projects/student`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching projects",
      };
    }
  },
  getAllProjects: async function () {
    if (!token) token = AppLib.token; // Get t
    try {
      const response = await axios.get(`${SERVER_URL}/projects`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching projects",
      };
    }
  },
  getProject: async function (id) {
    try {
      const response = await axios.get(`${SERVER_URL}/projects/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
        data: response.data.project,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching project",
      };
    }
  },
  deleteProject: async function (id) {
    try {
      const response = await axios.delete(`${SERVER_URL}/projects/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return {
        success: true,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while deleting project",
      };
    }
  },
  addSubmission: async function (formData) {
    try {
      const response = await axios.post(
        `${SERVER_URL}/projects/submit`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  resubmission: async function (id, formData) {
    try {
      const response = await axios.put(
        `${SERVER_URL}/projects/resubmit/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
  getSubmission: async function (id) {
    try {
      const response = await axios.get(
        `${SERVER_URL}/projects/submission/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching submission",
      };
    }
  },
  getSubmissions: async function (id) {
    try {
      const response = await axios.get(
        `${SERVER_URL}/projects/submissions/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "An error occurred while fetching submissions",
      };
    }
  },
  assessSubmission: async function (id, formData) {
    try {
      const response = await axios.put(
        `${SERVER_URL}/projects/assess/submission/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return {
        success: true,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message || error.message || "An error occurred",
      };
    }
  },
};

export default Projects;
